module.exports = "<div class='container-fluid full-height '>\r\n    <router-outlet></router-outlet>\r\n</div>"